import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowUp2Icon = ({ color = 'currentColor', size = 14, ref, ...props }) => {
    return (_jsx("svg", { ...props, width: size, height: size, stroke: color, ref: ref, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M11.2 9.09998L7.00001 4.89997L2.80001 9.09998", strokeWidth: "1.6" }) }));
};
//# sourceMappingURL=arrow-up2-icon.js.map